<template>
    <div>
        <div class="d-flex align-center">
            <v-avatar size="48" color="primary" class="mr-6">
                <v-icon size="36" class="white--text">mdi-account</v-icon>
            </v-avatar>
            <h2 class="text-uppercase">{{ caseDetails.fullName }}</h2>
            <span
                class="font-weight-regular text-subtitle-1 text-uppercase mt-1 ml-4"
                >ID: {{ caseDetails.casePartyId }}</span
            >
        </div>
        <v-divider class="my-2"></v-divider>
        <div class="d-flex">
            <h4 class="text-uppercase mr-2">Source:</h4>
            <span>{{ caseDetails.source }}</span>
            <h4 class="text-uppercase mx-2">Import Date:</h4>
            <span>{{ caseDetails.importDate }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        caseDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
</style>